var indexOf = [].indexOf;

import plural from 'helpers/plural';

import featureNames from 'constants/feature_names';

angular.module('gym.components').directive('enrolmentLimitSequenceCondition', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/enrolment_limit_sequence_condition.html.slim'),
    scope: {
      sequence: '=',
      step: '='
    },
    controller: ["$scope", "SequenceService", function($scope, SequenceService) {
      var getCondition;
      $scope.featureNames = featureNames;
      getCondition = function() {
        return $scope.condition = _.find($scope.step.sequence_conditions_attributes, function(condition) {
          return condition.type === 'EnrolmentLimitSequenceCondition' && !condition._destroy;
        });
      };
      getCondition();
      $scope.$watch('sequence.trigger', function(trigger, oldTrigger) {
        var ref;
        if (ref = $scope.sequence.trigger, indexOf.call($scope.sequence.enrolment_limit_triggers, ref) < 0) {
          return $scope.remove();
        }
      });
      $scope.getLabel = function() {
        var limitCountLabel, termLabel;
        limitCountLabel = plural('times', $scope.condition.limit_count, true);
        if ($scope.condition.limit_term_number) {
          termLabel = plural($scope.condition.limit_term_unit, $scope.condition.limit_term_number, $scope.condition.limit_term_number > 1);
        }
        if ($scope.condition.limit_to_current_month) {
          switch (false) {
            case $scope.condition.limit_count !== 1:
              return `Contact has not enrolled in this ${featureNames.SEQUENCE} in the current calendar month`;
            case !($scope.condition.limit_count > 1):
              return `Contact has enrolled in this ${featureNames.SEQUENCE} fewer than ${limitCountLabel} in the current calendar month`;
          }
        } else {
          switch (false) {
            case !($scope.condition.limit_count > 1 && !$scope.condition.limit_term_number):
              return `Contact has enrolled in this ${featureNames.SEQUENCE} fewer than ${limitCountLabel}`;
            case !($scope.condition.limit_count > 1 && $scope.condition.limit_term_number):
              return `Contact has enrolled in this ${featureNames.SEQUENCE} fewer than ${limitCountLabel} in the past ${termLabel}`;
            case !($scope.condition.limit_count === 1 && !$scope.condition.limit_term_number):
              return `Contact has not been enrolled in this ${featureNames.SEQUENCE} before`;
            case !($scope.condition.limit_count === 1 && $scope.condition.limit_term_number):
              return `Contact has not enrolled in this ${featureNames.SEQUENCE} in the past ${termLabel}`;
          }
        }
      };
      return $scope.remove = function() {
        return SequenceService.removeEnrolmentLimitSequenceCondition($scope.step);
      };
    }]
  };
});
